function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { CENTURY_STYLE } from '../constant';
var __vue_script__ = {
  name: 'DecadeTable',
  props: {
    prefixCls: String,
    locale: Object,
    value: Number,
    start: Number,
    end: Number
  },
  computed: {
    century: function () {
      var start = this.start;
      var century = [];
      var idx = 0;

      for (var i = 0; i < CENTURY_STYLE.row; i += 1) {
        century[i] = [];

        for (var j = 0; j < CENTURY_STYLE.col; j += 1) {
          var sYear = start - 10 + idx * 10;
          var eYear = sYear + 9;
          var name = "".concat(sYear, "-").concat(eYear);
          century[i].push({
            id: idx,
            title: name,
            name: name,
            start: sYear,
            end: eYear
          });
          idx += 1;
        }
      }

      return century;
    }
  },
  methods: {
    cellClasses: function cellClasses(col) {
      var _ref;

      var prefixCls = this.prefixCls,
          value = this.value,
          start = this.start,
          end = this.end;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-cell"), true), _defineProperty(_ref, "".concat(prefixCls, "-selected-cell"), value >= col.start && value <= col.end), _defineProperty(_ref, "".concat(prefixCls, "-last-century-cell"), col.start < start), _defineProperty(_ref, "".concat(prefixCls, "-next-century-cell"), col.start > end), _ref;
    },
    onSelect: function onSelect(col) {
      this.$emit('on-select', col.start);
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('table', {
    class: _vm.prefixCls + "-table",
    attrs: {
      "role": "grid",
      "cellSpacing": "0"
    }
  }, [_c('tbody', {
    class: _vm.prefixCls + "-tbody"
  }, _vm._l(_vm.century, function (row, i) {
    return _c('tr', {
      key: i,
      attrs: {
        "role": "row"
      }
    }, _vm._l(row, function (col, j) {
      return _c('td', {
        key: j,
        class: _vm.cellClasses(col),
        attrs: {
          "role": "gridcell"
        },
        on: {
          "click": function click() {
            return _vm.onSelect(col);
          }
        }
      }, [_c('a', {
        class: _vm.prefixCls + "-decade"
      }, [_vm._v("\n          " + _vm._s(col.name) + "\n        ")])]);
    }), 0);
  }), 0)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "decadeTable.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);